<template>
  <!-- {{schema}} -->
  <d-table
    :data_object="data_object"
    :getFreshData="true"
    :alwaysUpdate="true"
    :hasSearch="true"
    :allEditable="true"
    :insertable="true"
    :searchLen="3"
    addButtonCaption="New Permission"
    :editRow="false"
    :fields_excluded="fields_excluded"
  />
</template>

<script>
import axios from "axios";
import errorsHandler from "../../utils/errorsHandler";
import sucessHandler from "../../utils/successHandler";
import DTable from "../../components/Table";
import * as fun from "../../plugins/common";

export default {
  name: "Users",
  components: { DTable },
  data: () => ({
    fields_excluded: [],
    data_object: {
      object_name: "permissions",
      db_name: "master",
      all_records: true,
    },

    users: [],
    dataLoaded: false,

    loading: false,
    rolesLoading: false,
    allRoles: [],
    portalsLoading: false,
    allPortals: [],
  }),

  mounted() {
    // this.fetchUsers();
  },

  methods: {},
};
</script>

<style scoped></style>
